import React, { useEffect, useRef, useState } from "react";
import NcImage from "components/NcImage/NcImage";
import SingleHeader from "app/(singles)/SingleHeader";
import { Link, useParams } from "react-router-dom";
import { BACKEND_URL } from "constants";
import SectionSliderCards from "components/Sections/SectionSliderCard";

const PageSingle = () => {
  const params = useParams();

  const [data, setData] = useState([]);
  const [articles, setArticles] = useState([]);
  const [adverts, setAdverts] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialized = useRef(false);

  const text = data[0]?.long_description || "";

  // 🔎 reading time
  const plainText = text.replace(/<[^>]+>/g, " ");
  const wordsCount = plainText.split(/\s+/).filter(Boolean).length;
  const readingTime = Math.ceil(wordsCount / 200);

  // 🔁 ARTICLE
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;

      fetch(`${BACKEND_URL}/article/${+params.id}`)
        .then((r) => r.json())
        .then((r) => {
          if (!r.hasOwnProperty("error")) {
            setData(Array.isArray(r) ? r : [r]);
          }
        })
        .catch(console.error);
    }
  }, [params.id]);

  // 🔁 ARTICLES
  useEffect(() => {
    fetch(`${BACKEND_URL}/articles`)
      .then((r) => r.json())
      .then((r) => {
        if (!r.hasOwnProperty("error")) setArticles(r);
      })
      .catch(console.error);
  }, []);

  // 🔁 ADVERTS
  useEffect(() => {
    fetch(`${BACKEND_URL}/get-adverts`)
      .then((r) => r.json())
      .then((r) => {
        if (!r.hasOwnProperty("error")) {
          setAdverts(r);
          setLoading(false);
        }
      })
      .catch(console.error);
  }, []);

  const filtered = articles.filter(
    (a) => a.type === data[0]?.type
  );

  return (
    <div className="nc-PageSingle pt-8 lg:pt-16">
      {/* HEADER */}
      <header className="container single-responsive">
        <SingleHeader data={data} />
      </header>

      {/* MAIN LAYOUT */}
      <div className="container single-layout">

        {/* LEFT */}
        <div className="article-column">

          {/* CONTENT */}
          <div
            className="article-content"
            dangerouslySetInnerHTML={{
              __html: data[0]?.long_description || "",
            }}
          />

          {/* MEDIA */}
          <div className="media-block">
            {data[0]?.type === "image" && data[0]?.image && (
              <NcImage
                alt="image"
                className="w-full image-resp"
                src={data[0].image}
                width={1000}
                height={900}
                sizes="(max-width: 1024px) 100vw, 1280px"
              />
            )}

            {data[0]?.type === "wideo" && (
              <video
                src={data[0]?.video}
                poster={data[0]?.image}
                controls
                width={1000}
                height={900}
              />
            )}

            {data[0]?.date && (
              <span className="meta">
                {new Date(data[0].date).toLocaleString()}
              </span>
            )}

            {wordsCount > 0 && (
              <span className="meta">
                Szacowany czas czytania:{" "}
                <b>{readingTime} min</b>
              </span>
            )}
          </div>
        </div>

        {/* ADS */}
        {loading ? (
          <span>Wczytywanie reklam...</span>
        ) : (
          <aside className="ads-column">

            {/* TOP AD */}
            <Link to={adverts[14]?.link}>
              <img
                src={adverts[14]?.photo}
                loading="eager"
                fetchPriority="high"
                alt="Reklama"
                className="ad-banner"
              />
            </Link>

            {/* <div className="ad-spacer" /> */}

            {/* BOTTOM AD */}
            <Link to={adverts[15]?.link}>
              <img
                src={adverts[15]?.photo}
                alt="Reklama"
                className="ad-banner"
              />
            </Link>
          </aside>
        )}
      </div>

      {/* RELATED */}
      <div className="container">
        <SectionSliderCards
          className="py-16"
          postCardName="card10"
          heading="Zobacz też"
          subHeading="Inne Artykuły"
          posts={filtered
            .slice(0, 7)
            .filter((a) => a.id != params.id)
            .reverse()}
        />
      </div>

      {/* STYLE */}
      <style jsx>{`
        .single-layout {
          display: flex;
          gap: 40px;
          align-items: stretch;
        }

        .article-column {
          flex: 1;
          min-width: 0;
        }

        .article-content {
          font-family: Lato !important;
          font-size: 22px;
          text-align: justify;
          line-height: 1.8;
        }

        .ads-column {
          width: 320px;
          display: flex;
          flex-direction: column;
          gap: 24px;
          position: sticky;
          top: 100px;
          height: fit-content;
        }

        .ad-banner {
          width: 100%;
          border-radius: 12px;
          display: block;
        }

        .ad-spacer {
          flex: 1;
        }

        .media-block {
          margin-top: 40px;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .meta {
          color: grey;
          font-weight: 700;
        }

        @media (max-width: 1024px) {
          .single-layout {
            flex-direction: column;
          }

          .ads-column {
            width: 100%;
          }

          .ad-spacer {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default PageSingle;